import styled from 'styled-components'
import {formatDate, getFirstDayOfMonth} from '../../../utils/time'
import React from 'react'

const GroupHeader = styled.div`
  text-align: center;
  text-justify: auto;
  text-transform: uppercase;
  color: #191919;
  font-size: 14px;
  border-bottom: 1px solid #f3f5fb;
  padding-top: 16px;
  padding-bottom: 16px;
`

const GroupMonth = styled.span`
  color: black;
  font-weight: bold;
  margin-right: 4px;
`

export const renderGrouping = groupTime => {
  let groupDate = new Date(parseInt(groupTime))
  return (
    <GroupHeader>
      <GroupMonth>{formatDate(groupDate, 'MMMM')}</GroupMonth>
      {formatDate(groupDate, 'YYYY')}
    </GroupHeader>
  )
}

export const groupReservations = reservations =>
  reservations.reduce((acc, item) => {
    const {reserveDateStart} = item
    let dateStart = getFirstDayOfMonth(reserveDateStart).getTime()

    if (acc[dateStart]) {
      acc[dateStart].push(item)
    } else {
      acc[dateStart] = [item]
    }
    return acc
  }, {})
